import Vue from 'vue';
export default Vue.extend({
    props: {
        selected: {
            type: Number,
            default: null,
        },
        value: {
            type: [Boolean, Number],
            required: true,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isActive() {
            if (this.selected !== null) {
                return this.selected === this.value;
            }
            return !!this.value;
        },
    },
    methods: {
        handleClick() {
            if (!this.disabled) {
                this.$emit('input', !this.value);
                this.$emit('selectedChange', this.value);
                this.$emit('zeroDiscount');
            }
        },
    },
});
